import TextLink, { TextLinkProps } from './TextLink';

export default TextLink;

export type { TextLinkProps };

